import styled from 'styled-components'

export const ProductContainer = styled.div`
  position: relative;
  /* background-color: #f2f4f8; */
  @media screen and (min-width: 1100px) {
  }
  #similar-products{
    padding-bottom: 0 !important;
  }
`

export const ProductBreadcrumb = styled.div`
  padding: 30px 0 5px 0;
  background-color: white;
  @media screen and (max-width: 1100px) {
    padding: 15px 0 5px 0;
  }
`

export const AditionalInformation = styled.div`
  width: 100%;
  margin-top: 20px;
  padding-bottom: 40px;
  background-color: white;
  position: relative;
  display: grid;
  grid-row-gap: 50px;
  @media screen and (min-width: 1100px) {
  }
  h2[id|='product'] {
    margin-top: -100px;
    padding-top: 100px;
  }
`

export const InformationRoute = styled.div`
  width: 100%;
  left: 0px;
  top: 0px;
  position: sticky;
  background-color: white;
  border-bottom: 1px solid #eaeaea;

  .slick-slider {
    .slick-dots {
      display: none !important;
    }
  }

  .route-item {
    padding: 33px 26px 26px 26px;
    outline: none;
    a {
      font-size: 16px;
      color: ${props => props.theme.color.black2};
      text-decoration: none;
    }
    &.active {
      border-bottom: 1px solid #ffa502;
    }
  }
  @media screen and (min-width: 1100px) {
  }
`
